/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef, } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { useParams } from "react-router-dom";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import clsx from 'clsx';
import productActions from "../../../../Product/Product/redux/actions";
import { TextField } from "@mui/material";
import unitActions from "../../../../Product/Setup/redux/actions";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { NavLink } from "react-router-dom";
import { ListTable } from "./ListTable";
import { useDispatch, useSelector } from "react-redux";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { checkViewPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";

const InventoryTransaction = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData, exportLoader } = useSelector(state => state.crudReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);

    const dispatch = useDispatch();
    const { history } = props;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    let { productId } = useParams();
    const decryptedId = AESDecrypt(productId);
    const [topBar, setTopBar] = useState({
        productId: productId ? decryptedId : ''
    });
    const timeoutRef = useRef(null);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(topBar, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(topBar, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Inventory Transaction', history, 'Product')) {
                loadTasks();
            }
        }
    }, [roleManagement]);


    const loadTasks = useCallback(() => {
        dispatchFilter(topBar, sortBy, sortOrder);
        productApi('', topBar?.productId || '');
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id desc'
            }
        });
    });

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const dispatchFilter = (topBar, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ inventory_lot: { like: '%' + search.trim() + '%' } });
            or['or'].push({ reference_type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ inventory_status: { like: '%' + search.trim() + '%' } });
            or['or'].push({ party_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ financial_reference: { like: '%' + search.trim() + '%' } });
        }
        
        if (topBar?.productId) {
            filter['and'].push({ productId: parseInt(topBar?.productId) });
        }

        if (topBar?.unitId) {
            filter['and'].push({ unitId: parseInt(topBar?.unitId) });
        }


        if (or.or.length > 0) {
            filter['and'].push(or);
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'inventory-transactions',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ inventory_lot: { like: '%' + search.trim() + '%' } });
            or['or'].push({ reference_type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ inventory_status: { like: '%' + search.trim() + '%' } });
            or['or'].push({ party_name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ financial_reference: { like: '%' + search.trim() + '%' } });
        }

        if (topBar?.productId) {
            filter['and'].push({ productId: parseInt(topBar?.productId) });
        }

        if (topBar?.unitId) {
            filter['and'].push({ unitId: parseInt(topBar?.unitId) });
        }


        if (or.or.length > 0) {
            filter['and'].push(or);
        }



        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'inventory-transactions',
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(topBar, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(topBar, sortBy, sortOrder, s);
    }

    const changeHandler = (name, e) => {
        let data = {
            ...topBar,
            [name]: e
        };
        setTopBar(data);
        if (name !== 'displayType')
            dispatchFilter(data, sortBy, sortOrder);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                cls={'newImg'} img={ProductIcon} title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Inventory Transaction', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Inventory Transaction'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Inventory Transaction', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Lot ID, Source, Status, Party Name, and Financial Ref'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                                id={idNamingConversion('Search', 'inventoryTransaction', 'TextField')}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight,
                                    classes.removeUnderline, classes.customerLabelNone)}>

                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Inventory Transaction', 'Action', 'Display Type') &&
                                            <AutoCompleteComponent
                                                customLabel={"Display Type"}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={[{ id: 'name', name: "Name" }, { id: 'description', name: "Description" }]}
                                                parentValue={customObject([{ id: 'name', name: "Name" }, { id: 'description', name: "Description" }], topBar?.displayType)}
                                                customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                                position={"bottom"}
                                                id={idNamingConversion('Display Type', 'inventoryTransaction', 'DropDown')}
                                                variant={'outlined'}
                                                onChangeText={(data) => {
                                                    if (data === '') {
                                                        changeHandler('displayType', '')
                                                    }
                                                }}
                                                searchType={(s) => productApi(s)}
                                                onChange={(data) => {
                                                    changeHandler('displayType', data.id)
                                                }}
                                            />
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Inventory Transaction', 'Action', 'Product Filter') &&
                                            <AutoCompleteComponent
                                                customLabel={"All Product"}
                                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                                { 'key': 'productId', 'name': 'Product ID' },
                                                { 'key': 'code', 'name': 'Product Code' }]}
                                                details={myProductdetails}
                                                parentValue={customObject(myProductdetails, topBar?.productId)}
                                                customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                                position={"bottom"}
                                                id={idNamingConversion('All Product', 'inventoryTransaction', 'DropDown')}
                                                variant={'outlined'}
                                                onChangeText={(data) => {
                                                    if (data === '') {
                                                        changeHandler('productId', '')
                                                    }
                                                }}
                                                searchType={(s) => productApi(s)}
                                                onChange={(data) => {
                                                    changeHandler('productId', data.id)
                                                }}
                                            />
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Inventory Transaction', 'Action', 'Export') &&
                                            <NavLink
                                                to="#"
                                                id={idNamingConversion('Export', 'inventoryTransaction', 'Link')}
                                                onClick={() => { loadImportExportData('Inventory Transaction'); }}
                                                className={clsx(classes.customLink, { ['three_loader']: exportLoader })}>
                                                 {
                                                    !exportLoader && <><Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span></>
                                                }
                                            </NavLink>
                                        }
                                    </Space>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                topBar={topBar}
                                loadTasks={() => dispatchFilter(topBar, sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            {/* <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Customers'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerDetails}
                loadTasks={() => { dispatchFilter(filterGroupId, sortBy, sortOrder) }}
            /> */}
        </React.Fragment>
    )
}
export default InventoryTransaction